let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("d3NPH")).then(() => parcelRequire('48Ka6'));